(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (this.classList.contains('puane-header--overlay')) {
        this.header.classList.add('puane-section-header--overlay');
      }
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puane-product-mobile-fixes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const isColorName = (name) => /renk|color|colour/i.test(name || '');

    const lotQuantity = (value) => {
      const normalized = String(value || '').trim();
      if (!normalized) return 1;
      const centralQuantity = window.PuaneLotRules?.count(normalized);
      if (centralQuantity) return centralQuantity;
      const stdMatch = normalized.match(/^STD\s*[-/:]?\s*(\d+)$/i);
      if (stdMatch) return Math.max(1, Number(stdMatch[1]));
      const parts = normalized.split(/[\s,\/-]+/).filter(Boolean);
      return Math.max(1, parts.length);
    };

    const selectedLotValue = (picker) => {
      if (!picker) return '';
      const checked = Array.from(picker.querySelectorAll('input[data-option-name]:checked'))
        .find((input) => !isColorName(input.dataset.optionName));
      if (checked) return checked.value;
      const selected = Array.from(picker.querySelectorAll('select option:checked'))
        .find((option) => !isColorName(option.dataset.optionName));
      return selected ? selected.value : '';
    };

    const applyLotQuantity = (picker) => {
      const quantity = lotQuantity(selectedLotValue(picker));
      const sectionId = picker?.dataset.section;
      const product = sectionId ? document.getElementById(`MainProduct-${sectionId}`) : document.querySelector('[id^="MainProduct-"]');
      const form = product?.querySelector('form[action*="/cart/add"]');
      const input = form?.querySelector('input[name="quantity"]');
      if (!input) return;

      input.min = String(quantity);
      input.step = String(quantity);
      input.dataset.puaneLotStep = String(quantity);
      const current = Math.max(quantity, Number(input.value || quantity));
      input.value = String(Math.ceil(current / quantity) * quantity);

      let note = form.querySelector('[data-puane-lot-note]');
      if (!note) {
        note = document.createElement('small');
        note.dataset.puaneLotNote = 'true';
        note.className = 'puane-product-lot-note';
        input.closest('.quantity')?.after(note);
      }
      if (note) note.textContent = `Lot: ${quantity} adet · Seri bölünmez`;
    };

    const imageCode = (source) => {
      const cleanSource = decodeURIComponent((source || '').split('?')[0]);
      const filename = cleanSource.split('/').pop() || '';
      const match = filename.match(/_([^_]+)_\d+\.[^.]+$/i);
      return match ? match[1] : '';
    };

    const selectedColorCodes = (picker) => {
      const checkedInput = Array.from(picker.querySelectorAll('input[data-option-name]:checked'))
        .find((input) => isColorName(input.dataset.optionName));

      if (checkedInput) {
        return Array.from((checkedInput.dataset.puaneColorCodes || '').matchAll(/\|([^|]+)\|/g), (match) => match[1]);
      }

      const selectedOption = Array.from(picker.querySelectorAll('select option:checked'))
        .find((option) => isColorName(option.dataset.optionName));

      return selectedOption
        ? Array.from((selectedOption.dataset.puaneColorCodes || '').matchAll(/\|([^|]+)\|/g), (match) => match[1])
        : [];
    };

    const updateCounter = (gallery, visibleSlides, activeIndex = 0) => {
      const current = gallery.querySelector('.slider-counter--current');
      const total = gallery.querySelector('.slider-counter--total');
      if (current) current.textContent = String(activeIndex + 1);
      if (total) total.textContent = String(visibleSlides.length);
    };

    const filterGallery = (picker) => {
      const sectionId = picker.dataset.section;
      const gallery = document.getElementById(`MediaGallery-${sectionId}`);
      if (!gallery) return;

      const codes = selectedColorCodes(picker);
      if (!codes.length) return;

      const list = gallery.querySelector('[id^="Slider-Gallery-"]');
      if (!list) return;

      const slides = Array.from(list.querySelectorAll('.product__media-item'));
      const matchingSlides = slides.filter((slide) => {
        const image = slide.querySelector('.product__media img');
        return codes.includes(imageCode(image?.currentSrc || image?.src));
      });

      // Fotoğraf eşleşmesi yoksa müşterinin mevcut galerisi değiştirilmez.
      if (!matchingSlides.length) return;

      const visibleIds = new Set(matchingSlides.map((slide) => slide.dataset.mediaId));
      slides.forEach((slide) => {
        slide.hidden = !visibleIds.has(slide.dataset.mediaId);
      });

      gallery.querySelectorAll('.thumbnail-list__item[data-target]').forEach((thumbnail) => {
        thumbnail.hidden = !visibleIds.has(thumbnail.dataset.target);
      });

      const firstSlide = matchingSlides[0];
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(firstSlide.dataset.mediaId, true);
      }

      requestAnimationFrame(() => {
        list.scrollTo({ left: firstSlide.offsetLeft, behavior: 'auto' });
        updateCounter(gallery, matchingSlides, 0);
      });

      if (!list.dataset.puaneCounterBound) {
        list.dataset.puaneCounterBound = 'true';
        list.addEventListener('scroll', () => {
          const visible = Array.from(list.querySelectorAll('.product__media-item:not([hidden])'));
          if (!visible.length) return;
          const closestIndex = visible.reduce((bestIndex, slide, index) => {
            const bestDistance = Math.abs(visible[bestIndex].offsetLeft - list.scrollLeft);
            const distance = Math.abs(slide.offsetLeft - list.scrollLeft);
            return distance < bestDistance ? index : bestIndex;
          }, 0);
          updateCounter(gallery, visible, closestIndex);
        }, { passive: true });
      }
    };

    const initialize = (scope = document) => {
      scope.querySelectorAll('variant-selects[data-section]').forEach((picker) => {
        filterGallery(picker);
        applyLotQuantity(picker);
      });
    };

    document.addEventListener('change', (event) => {
      const picker = event.target.closest('variant-selects[data-section]');
      if (!picker || !isColorName(event.target.dataset.optionName)) return;
      window.setTimeout(() => filterGallery(picker), 60);
      window.setTimeout(() => filterGallery(picker), 300);
    });

    document.addEventListener('change', (event) => {
      const picker = event.target.closest('variant-selects[data-section]');
      if (!picker) return;
      window.setTimeout(() => applyLotQuantity(picker), 80);
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.quantity__button');
      if (!button) return;
      const form = button.closest('form[action*="/cart/add"]');
      const input = form?.querySelector('input[name="quantity"]');
      const step = Number(input?.dataset.puaneLotStep || 1);
      if (!input || step <= 1) return;
      window.setTimeout(() => {
        const value = Math.max(step, Number(input.value || step));
        input.value = String(Math.ceil(value / step) * step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }, 0);
    });

    document.addEventListener('DOMContentLoaded', () => initialize());
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    initialize();
  })();

  } catch(e) { console.error(e); }
})();
})();
